"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _config = require("../../services/config");
var _actions = require("./store/actions");
var _selectors = require("./store/selectors");
var _Form = _interopRequireDefault(require("./Form"));
var _constants = require("./constants");
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    disabledForm: (0, _selectors.shouldDisableForm)(state),
    initialValuesFromRedux: (0, _selectors.getInitialValues)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onMount: function onMount() {
      return dispatch((0, _actions.startListentBrowserBackAction)(_constants.MAIN_QUERY_ID));
    },
    onUnMount: function onUnMount() {
      dispatch((0, _actions.trackUnmountedSearchForm)());
    },
    onReset: function onReset() {
      return dispatch((0, _actions.resetForm)(_constants.MAIN_QUERY_ID));
    },
    onSearch: function onSearch(values) {
      return dispatch((0, _actions.search)(_constants.MAIN_QUERY_ID, values));
    },
    openPageBySearchOfferID: function openPageBySearchOfferID() {
      return dispatch((0, _actions.openPageBySearchOfferID)());
    }
  };
};
var FormMiddleware = function FormMiddleware(_ref) {
  var disabledForm = _ref.disabledForm,
    initialValuesFromRedux = _ref.initialValuesFromRedux,
    values = _ref.values,
    setValues = _ref.setValues,
    submitForm = _ref.submitForm,
    onMount = _ref.onMount,
    onReset = _ref.onReset,
    onUnMount = _ref.onUnMount;
  (0, _react.useEffect)(function () {
    var EXCLUDED_KEYS_TO_COMPARE = [_fn.QUERY_PARAMS.AUTOSTART, _fn.QUERY_PARAMS.GROUP];
    var shouldUpdateValues = !R.equals(R.omit(EXCLUDED_KEYS_TO_COMPARE, initialValuesFromRedux), R.omit(EXCLUDED_KEYS_TO_COMPARE, values));
    if (shouldUpdateValues) {
      setValues(initialValuesFromRedux);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValuesFromRedux]);
  (0, _react.useEffect)(function () {
    onMount();
    return onUnMount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Form.default, {
    disabled: disabledForm,
    onReset: onReset,
    onSubmit: submitForm
  });
};
var enhancer = R.compose((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _formik.withFormik)({
  mapPropsToValues: R.prop('initialValuesFromRedux'),
  handleSubmit: function handleSubmit(values, _ref2) {
    var props = _ref2.props;
    if (props.disabledForm) {
      props.openPageBySearchOfferID();
    } else {
      var onClickBySearchButtonCallback = (0, _config.getOnClickBySearchButton)();
      if (!(0, _config.isDisableSearch)()) {
        (0, _helpers.saveCurrencyCode2LocalStorage)(values[_fn.QUERY_PARAMS.CURRENCY]);
        props.onSearch(values);
      }
      if (onClickBySearchButtonCallback) {
        onClickBySearchButtonCallback();
      }
    }
  }
}));
var _default = exports.default = enhancer(FormMiddleware);